"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var useToggle_1 = tslib_1.__importDefault(require("./useToggle"));
exports.default = useToggle_1.default;
